export default __webpack_public_path__ + "static/media/video-1.a1df454a.mp4";